import { API_URL } from 'consts/common.const';
import { Http } from 'services/http';

export interface MyProfile {
  updatedBy: string;
  userId: number;
  empName: string;
  roleName: string;
  role: number;
  phone: string;
  email: string;
  statusName: string;
  status: number;
  send_email: boolean;
  pathAvatar: string;
  username: string;
  userRights: string;
}

export const myProfile = () => {
  return Http.request<MyProfile>({
    method: 'GET',
    url: `${API_URL}/user/user_profile`,
  });
};
